import { useState } from 'react';

import { GetEquipmentTest } from 'services/equipmentTest/getEquipmentTest';

const useEquipmentTest = () => {
    const [dataEquipmentTest, setDataEquipmentTest] = useState<boolean | number>();

    const handleClearEquipmentTest = () => {
        setDataEquipmentTest(undefined);
    }

    const handleGetEquipmentTest = async (nrPLataforma: number) => {
        setDataEquipmentTest(undefined);
        const data = await GetEquipmentTest(nrPLataforma);

        if ((typeof data === 'number') && (data > 0)) {
            setDataEquipmentTest(data);
        } else {
            setDataEquipmentTest(false);
        }
    }

    return { dataEquipmentTest, handleGetEquipmentTest, handleClearEquipmentTest };
}

export default useEquipmentTest;